import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiBaseUrlInterceptor implements HttpInterceptor {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any --- HttpInterceptor interface requires any type
  intercept<_T>(req: HttpRequest<any>, next: HttpHandler) {
    let url = req.url;

    // Rewrite /api/ to versioned API path (e.g., /api/v1/)
    // This allows existing code using '/api/...' to work with versioned endpoints
    if (url.startsWith('/api/') && !url.startsWith('/api/v')) {
      url = url.replace('/api/', environment.apiConfig.apiUri + '/');
    } else if (url.startsWith('api/') && !url.startsWith('api/v')) {
      url = url.replace('api/', environment.apiConfig.apiUri.replace(/^\//, '') + '/');
    }

    // Rewrite /public-api/ to versioned public API path
    if (url.startsWith('/public-api/') && !url.startsWith('/public-api/v')) {
      url = url.replace('/public-api/', environment.apiConfig.publicApiUri + '/');
    } else if (url.startsWith('public-api/') && !url.startsWith('public-api/v')) {
      url = url.replace('public-api/', environment.apiConfig.publicApiUri.replace(/^\//, '') + '/');
    }

    // Prepend apiBaseUrl for API, OData, and public-api requests
    // Note: 'odata/' URLs are included here only for OData function calls via HttpClient.
    // For standard OData queries, prefer using ODataServiceFactory which has its own base URL configuration.
    if (
      url.startsWith('api/') ||
      url.startsWith('/api/') ||
      url.startsWith('odata/') ||
      url.startsWith('/odata/') ||
      url.startsWith('public-api/') ||
      url.startsWith('/public-api/')
    ) {
      const apiReq = req.clone({
        url: `${environment.apiConfig.apiBaseUrl}/${url.replace(/^\//, '')}`,
      });
      return next.handle(apiReq);
    }

    return next.handle(req);
  }
}
